module.exports = __webpack_public_path__ + "img/hx-zdhjc.78d3f894.svg";